import styled from 'styled-components'
import { Chiclet, Icon } from 'components'

const Trigger = styled(Chiclet)`
  ${({ theme: { colors } }) => `
    background: ${colors('chrome')};
    position: absolute;
    bottom: 2rem;
    right: 2rem;
    cursor: pointer;
  `}
`

export const Settings = () => {
  return (
    <Trigger>
      <Icon icon="cog-outline" />
    </Trigger>
  )
}
